import api from './api';

export const importedOrderService = {
  async list({ page = 1, limit = 20, search = '', matched, fromComeback, fromQuote, startDate, endDate } = {}) {
    const params = { page, limit };
    if (search) params.search = search;
    if (matched !== undefined && matched !== null) params.matched = matched;
    if (fromComeback) params.fromComeback = fromComeback;
    if (fromQuote) params.fromQuote = fromQuote;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await api.get('/imported-orders', { params });
    return response.data;
  },

  async getStats() {
    const response = await api.get('/imported-orders/stats');
    return response.data.data;
  },

  async get(id) {
    const response = await api.get(`/imported-orders/${id}`);
    return response.data.data;
  },
};
